import React from 'react'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icon from '~/Common-Objects/UI/Icon'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import supportTeamImage from '~/assets/images/misc/support-team.png'
import i18n from '~/i18n'
import './index.scss'

export default function SupportCallToAction({ emailUsPostHogTag, supportDocsPostHogTag }) {
    return (
        <Paper className={'support-call-to-action'}>
            <img
                src={supportTeamImage}
                alt='Headshots of all 5 members of the Transpond support team.'
                className={'support-call-to-action__img'}
            />
            <div className={'support-call-to-action__content'}>
                <h2 className='h6'>{i18n.t('dashboard:gettingStarted.support.heading')}</h2>
                <p>{i18n.t('dashboard:gettingStarted.support.body')}</p>
            </div>

            <div className={'support-call-to-action__ctas'}>
                <ButtonNew
                    href='https://transpond.io/contactus'
                    target='_blank'
                    iconLeft={<Icon name='envelope' />}
                    variant='secondary'
                    size='s'
                    data-ph={emailUsPostHogTag}
                >
                    {i18n.t('dashboard:gettingStarted.support.contactCta')}
                </ButtonNew>
                <ButtonNew
                    href='https://transpond.io/support'
                    target='_blank'
                    iconLeft={<Icon name='lifering' />}
                    variant='secondary'
                    size='s'
                    data-ph={supportDocsPostHogTag}
                >
                    {i18n.t('dashboard:gettingStarted.support.supportCta')}
                </ButtonNew>
            </div>
        </Paper>
    )
}
